var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","layout":"prev, pager, next","page-size":_vm.pagInaS.pageSize,"total":_vm.total,"current-page":_vm.pagInaS.pageNum,"hide-on-single-page":""},on:{"current-change":_vm.handleCurrentChange,"prev-click":_vm.handlePrevClick,"next-click":_vm.handleNextClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }